import React, { useState } from 'react';
import styles from './ContactModal.module.less';
import topImage from '@/assets/images/Top.png';
import { submitContactForm ,checkForm} from '@/utils/form.js';

export default function ContactModal({ visible, onClose, onToggle }) {


    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: '',
        product: []
    });

    const [isSuccess, setIsSuccess] = useState(false);

    // if (!visible) return null; // 不再直接返回 null，通过 CSS 控制显隐以支持动画

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {


        e.preventDefault();

        const result = await submitContactForm(formData);

        if (result.success) {
            setIsSuccess(true);
            alert('提交成功！我们将尽快与您联系。');

            setFormData({ name: '', email: '', phone: '', company: '', message: '', product: [] }); // 重置表单
        } else {
            alert('提交失败: ' + result.error);
        }
        onClose();
    };

    return (
        <div className={styles.overlay}>
            <div className={`${styles.modal} ${visible ? '' : styles.hidden}`} onClick={e => e.stopPropagation()}>
                <div className={styles.header}>
                    <img src={topImage} alt="Top" className={styles.topImg} />
                </div>
                <form className={styles.form} onSubmit={handleSubmit}>
                    <div className={styles.field}>
                        <input
                            type="text"
                            name="name"
                            placeholder="姓名*"
                            required
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </div>
                    <div className={styles.field}>
                        <input
                            type="email"
                            name="email"
                            placeholder="邮箱*"
                            required
                            value={formData.email}
                            onChange={handleChange}
                        />
                    </div>
                    <div className={styles.field}>
                        <input
                            type="tel"
                            name="phone"
                            placeholder="电话*"
                            required
                            value={formData.phone}
                            onChange={handleChange}
                        />
                    </div>
                    <div className={styles.field}>
                        <input
                            type="text"
                            name="company"
                            placeholder="公司*"
                            required
                            value={formData.company}
                            onChange={handleChange}
                        />
                    </div>
                    <div className={styles.field}>
                        <textarea
                            name="message"
                            placeholder="留言内容*"
                            required
                            value={formData.message}
                            onChange={handleChange}
                        />
                    </div>
                    <button type="submit" className={styles.submitBtn}>发送</button>
                </form>
            </div>

            <div className={`${styles.floatBtn} ${visible ? styles.active : ''}`} onClick={onToggle}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 7L10 12L15 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
        </div>
    );
}
